import { type PropsWithChildren, type ComponentProps, Fragment } from "react";
import styles from './Sidebar.module.css';
import { BUILD_NUMBER } from "@/configuration";

export interface SidebarProps extends PropsWithChildren, ComponentProps<'div'> {
    width?: number;
}

export default function Sidebar(props: SidebarProps) {
    let styleAttr;
    if (props.width) {
        styleAttr = {
            width: `${props.width}px`
        };
    }

    return (
            <div className={styles.sidebar} style={styleAttr}>
                <div className={styles.content}>
                    {props.children}
                </div>
                <div className={styles.version}>
                    v{BUILD_NUMBER}
                </div>
            </div>
    )
}
